/* global Modal, Toasts */
;$(function () {
  'use strict'

  const verifyEmailSelector = '[data-settings-verify-email-button]'

  $(verifyEmailSelector).on('click', function (e) {
    e.preventDefault()
    const $this = $(this)
    const $modal = $(this).closest('.modall')
    const verifyUrl = $this.data('url')
    const $preloader = $this.find('.button__preloader')

    $preloader.removeClass('layout__none')

    $.post(verifyUrl)
      .fail(function () {
        Toasts.pushToast('Что-то пошло не так, попробуйте позднее', 'fail', undefined, 5000)
      })
      .success(function () {
        Modal.closeModal($modal)
        Toasts.pushToast('Вам успешно отправлено письмо для подтвержения e-mail адреса', 'success', undefined, 5000)
      })
      .always(function () {
        $preloader.addClass('layout__none')
      })
  })

  const settingsTogglerSelector = '[data-settings-ntf-setting]'

  $(settingsTogglerSelector).on('click', function (e) {
    e.preventDefault()

    const $this = $(this)
    const kind = $this.data('kind')
    const isCurrentlyActive = parseInt($this.data('isActive'))
    const url = $this.data('url')
    const newActive = isCurrentlyActive ? 0 : 1
    const activeClass = 'settings-toggler_active'

    if (isCurrentlyActive) {
      $this.removeClass(activeClass)
    }
    else {
      $this.addClass(activeClass)
    }

    $.post(url, {
      kind: kind,
      is_active: newActive
    })
      .fail(function () {
        if (isCurrentlyActive) {
          $this.addClass(activeClass)
        }
        else {
          $this.removeClass(activeClass)
        }
        Toasts.pushToast('Что-то пошло не так, попробуйте позднее', 'fail toast_position_center', undefined, 5000)
      })
      .success(function () {
        $this.data('isActive', newActive)
        Toasts.pushToast('Изменения сохранены', 'success toast_position_center', undefined, 5000)
      })
      .always(function () {
      })
  })
})
